import { Button as WalrusButton, style } from '@do/walrus';
import styled from 'styled-components';
import vars from '../assets/overwrite-vars';

const Button = styled(WalrusButton)`
  margin-top: ${style.vars.whitespace.regular};
  border-radius: ${vars.border_radius_xlarge};
  background: ${vars.primary};
`;

export default Button;
